<template>
    <div>
        <nav class="breadcrumb bg-white push">
            <a class="breadcrumb-item" href="javascript:void(0)">Dashboard</a>
            <span class="breadcrumb-item active">Locations</span>
        </nav>

        <div class="block-content">
            <div class="row">
                <button
                    type="button"
                    class="btn btn-info text-white mr-5 mb-5"
                    @click.prevent="newModal"
                >
                    <i class="fa fa-plus mr-5"></i> Create Location
                </button>
            </div>
            <hr />
            <div class="row">
                <div class="col-sm-12 table-responsive">
                    <table
                        class="table table-bordered table-striped table-vcenter js-dataTable-simple dataTable no-footer"
                        id="DataTables_Table_0"
                        role="grid"
                        aria-describedby="DataTables_Table_0_info"
                    >
                        <thead>
                            <tr role="row">
                                <th class="text-capitalize">Country</th>
                                <th class="text-capitalize">Address</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                role="row"
                                class="odd"
                                v-for="(location, index) in locations"
                                :key="location.id"
                            >
                                <td>
                                    {{ location.country }}
                                </td>
                                <td>
                                    {{ location.address }}
                                </td>
                                <td>
                                    <button
                                        type="button"
                                        class="btn btn-sm btn-danger"
                                        data-toggle="tooltip"
                                        title="Delete"
                                        @click.prevent="deleteLocation(location.id)"
                                    >
                                        <i class="fa fa-trash"></i>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div
            class="modal fade"
            id="modal-fadein"
            tabindex="-1"
            role="dialog"
            aria-labelledby="modal-fadein"
            style="display: none;"
            aria-hidden="true"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h3 class="card-title">Add Location</h3>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <!-- Beginning of the form -->
                    <form @submit.prevent="createLocation">
                        <div class="modal-body">
                            <div class="card">
                                <div class="card-body">
                                    <div class="form-group">
                                        <label for="name" class="text-muted"
                                            >Country</label
                                        >
                                        <input
                                            v-model="form.country"
                                            type="text"
                                            class="form-control"
                                            id="name"
                                            required
                                        />
                                    </div>
                                    <div class="form-group">
                                        <label for="name" class="text-muted"
                                            >Address</label
                                        >
                                        <input
                                            v-model="form.address"
                                            type="text"
                                            class="form-control"
                                            id="name"
                                            required
                                        />
                                    </div>
                                    <button
                                        :disabled="processing"
                                        type="submit"
                                        class="btn btn-lg btn-outline-success mb-2"
                                    >
                                        {{
                                            processing ? "processing" : "Create"
                                        }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { RepositoryFactory } from "../../../repository/RepositoryFactory";

const UsersRepository = RepositoryFactory.get("users");
export default {
    data() {
        return {
            locations: [],
            processing: false,
            coinpayment: "",
            form: new Form({
                id: "",
                address: "",
                country: "",
            })
        };
    },
    methods: {
        newSetUp() {
            this.editmode = false;
            this.form.reset();
            $("#modal-fadein2").modal("show");
        },

        newModal() {
            this.editmode = false;
            this.form.reset();
            $("#modal-fadein").modal("show");
        },
        editModal(location) {
            this.editmode = true;
            this.form.reset();
            $("#modal-fadein").modal("show");
            this.form.fill(location);
        },
        async createLocation() {
            try {
                await UsersRepository.createLocation({
                    address: this.form.address,
                    country: this.form.country,
                });
                toast.fire({
                    type: "success",
                    title: "Location created successfully"
                });
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
            } catch (error) {
                toast.fire({
                    type: "warning",
                    title: "Failed to create location"
                });
            }
        },
        async deleteLocation($id) {
            try {
                await UsersRepository.deleteLocation($id);
                toast.fire({
                    type: "success",
                    title: "Location deleted successfully"
                });
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
            } catch (error) {
                toast.fire({
                    type: "warning",
                    title: "Failed to delete location"
                });
            }
        },
     
        loadLocations() {
            UsersRepository.viewLocations().then(response => {
                this.locations = response.data;
            });
        }
    },
    created() {
        this.loadLocations();
    }
};
</script>
